import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export function useDeleteIcv() {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.delete("/api/icvs/" + id);
            return response;
        },
        onSuccess: () => queryClient.invalidateQueries(["allIcvs"]),
    });

    return query;
}
